import { FormControl, FormLabel, Grid, Option } from "@mui/joy";
import DarkCard from "../../../common/DarkCard";
import DarkSelect from "../../../common/DarkSelect";
import DarkTypography from "../../../common/DarkTypography";
import type { MailTemplate } from "../../../../api/mailTemplates/MailTemplate.typed";
import type { TrainingTemplate } from "../../../../api/training/Training.typed";

type MailField =
  | "MailTemplateStartID"
  | "MailTemplateAddedID"
  | "MailTemplateAccessID"
  | "MailTemplateEndID";

const MAIL_FIELDS: { field: MailField; label: string }[] = [
  { field: "MailTemplateStartID", label: "Début de formation" },
  { field: "MailTemplateAddedID", label: "Ajout de formation" },
  { field: "MailTemplateAccessID", label: "Accès à la formation" },
  { field: "MailTemplateEndID", label: "Fin de formation" },
];

const NONE_VALUE = "none";

type TrainingTemplateMailsCardProps = {
  selected: TrainingTemplate;
  canEdit: boolean;
  mailTemplates: MailTemplate[];
  onMailTemplateChange: (field: MailField, templateId: number) => void;
};

export default function TrainingTemplateMailsCard(props: TrainingTemplateMailsCardProps) {
  const { selected, canEdit, mailTemplates, onMailTemplateChange } = props;

  return (
    <Grid xs={12}>
      <DarkCard dense sx={{ mt: 2 }}>
        <DarkTypography colorVariant="accent" sx={{ mb: 1 }}>
          E-mails de formation
        </DarkTypography>
        <Grid container spacing={2}>
          {MAIL_FIELDS.map(({ field, label }) => {
            const current = selected[field];
            const selectedId = current != null && current > 0 ? current : 0;
            const selectValue = selectedId > 0 ? String(selectedId) : NONE_VALUE;
            const boundMissing =
              selectedId > 0 && !mailTemplates.some((tpl) => tpl.id === selectedId);

            return (
              <Grid key={field} xs={12} sm={6} sx={{ minWidth: 0 }}>
                <FormControl sx={{ minWidth: 0 }}>
                  <FormLabel>{label}</FormLabel>
                  <DarkSelect
                    placeholder="Aucun"
                    value={selectValue}
                    disabled={!canEdit}
                    onChange={(_event, sel) => {
                      if (sel == null || sel === NONE_VALUE) {
                        onMailTemplateChange(field, 0);

                        return;
                      }

                      const next = Number(sel);
                      onMailTemplateChange(field, Number.isFinite(next) && next > 0 ? next : 0);
                    }}
                  >
                    <Option value={NONE_VALUE}>Aucun</Option>
                    {boundMissing ? (
                      <Option value={String(selectedId)}>{`Modèle #${selectedId}`}</Option>
                    ) : null}
                    {mailTemplates.map((tpl) =>
                      tpl.id != null && tpl.id > 0 ? (
                        <Option key={tpl.id} value={String(tpl.id)}>
                          {tpl.name || `Modèle #${tpl.id}`}
                        </Option>
                      ) : null,
                    )}
                  </DarkSelect>
                </FormControl>
              </Grid>
            );
          })}
        </Grid>
      </DarkCard>
    </Grid>
  );
}
